import { render, staticRenderFns } from "./ElcForm.vue?vue&type=template&id=8a2794ce&"
import script from "./ElcForm.vue?vue&type=script&lang=js&"
export * from "./ElcForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports